<template>
    <div class="g-body">
        <div class="result-wrap">
            <div class="info">
                <div class="info-title">赵平的分享</div>
                <div class="info-row">记录编号：发生顶顶顶顶的点点滴滴哒哒哒哒哒哒哒哒哒</div>
                <div class="info-row">记录编号：32323</div>

                <div class="info-title">备注</div>
                <div class="info-row">
                    记录编号：发生顶顶顶顶的点点滴滴哒哒哒哒哒哒哒哒哒
                    <br />
                    记录编号：发生顶顶顶顶的点点滴滴哒哒哒哒哒哒哒哒哒
                </div>
            </div>
            <div class="content">
                <div class="tab">
                    <div class="c-title">居住信息 1/4</div>
                    <div class="c-question">1、家中常住家庭成员及年龄</div>
                    <div class="c-answer">选项：自己+配偶+1个孩子</div>
                    <div class="c-question">2、家中常住家庭成员及年龄</div>
                    <div class="c-answer">选项：自己+配偶+1个孩子</div>
                </div>
                <div class="tab">
                    <div class="c-title">房屋信息 1/8</div>
                    <div class="c-question">3、家中常住家庭成员及年龄</div>
                    <div class="c-answer">选项：自己+配偶+1个孩子</div>
                    <div class="c-question">4、家中常住家庭成员及年龄</div>
                    <div class="c-q-img-box">
                        <span class="c-q-img-div">
                            <img
                                class="c-q-img"
                                src="https://dpwcc.voglassdc.com/bpm/test/design/qa/images/枫叶1733899204267.png"
                                alt=""
                                obj-contain="contain"
                            />
                            <span class="c-q-img-text-div">
                                <span class="c-q-img-text">图片一</span>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="repart">
                    <div class="info-title">需求分析报告</div>
                    <div class="info-row">我的装修人格：精致生活家</div>
                    <div class="r-tab">居住者信息</div>
                    <div class="r-row">
                        标签：嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息
                    </div>
                    <div class="r-row">
                        解读：嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息
                    </div>
                    <div class="r-row r-title">
                        第一居所
                    </div>
                    <div class="r-row">
                        这是第一居所相关
                    </div>

                    <div class="r-tab">房屋信息</div>
                    <div class="r-row">
                        标签：嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息
                    </div>
                    <div class="r-row">
                        解读：嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻信息
                    </div>
                    <div class="r-row r-title">
                        第二居所
                    </div>
                    <div class="r-row">
                        这是第二居所相关
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
<style>
div.product-main {
    /* top: 0; */
}
.g-body {
    /* top: 0; */
}
</style>
<style lang="less" scoped>
.result-wrap {
    width: 700px;
    // height: 1351px;
    margin: 0 auto 30px;
    padding: 0 50px 50px;
    box-sizing: border-box;
    background-color: #fff;
    font-family: PingFangSC, PingFang SC;
}
.info {
}
.info-title {
    padding: 50px 0 10px;
    font-size: 29px;
    font-weight: 700;
}
.info-row {
    font-size: 19px;
    line-height: 2em;
    color: #666;
}
.tab {
}
.c-title {
    padding: 50px 0 10px;
    font-size: 29px;
    font-weight: 600;
}
.c-question,
.c-answer {
    font-size: 19px;
    line-height: 2.2em;
    color: #666;
}
.c-answer + .c-question {
    padding-top: 20px;
}
.c-q-img-box {
    width: 700px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
}
.c-q-img-div {
    width: 144px;
    max-height: 204px;
    margin-right: 8px;
    margin-bottom: 8px;
    display: inline-block;
    background: #f3f3f3;
    border-radius: 6px;
    font-size: 0;
}
.c-q-img-text-div {
    width: 100%;
    height: 60px;
    padding: 8px 8px 12px;
    background: #e8e7e7;
    display: inline-block;
    border-radius: 0 0 6px 6px;
    box-sizing: border-box;
}
.c-q-img-text {
    line-height: 1.5em;
    width: 100%;
    font-size: 12px;
    color: #666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    height: 40px;
}
.c-q-img {
    width: 144px;
    height: 144px;
    object-fit: contain;
}

.repart {
}
.r-tab {
    padding-top: 30px;
    font-size: 19px;
    font-weight: 600;
    line-height: 2em;
    color: #333;
}
div.r-title {
    padding-top: 4px;
    text-decoration: underline;
}
.r-row {
    font-size: 20px;
    line-height: 1.8em;
    color: #666;
    width: 700px;
    overflow-wrap: break-word;
}
</style>
